import React, { useEffect, useMemo, useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import auth from "../../services/authService";
import Joi from "joi-browser";
import UploadDocument from "../../comman/UploadDocument";
import { getAlert, getConfirmAlert } from "../../services/appAlerts";
import Input from "../../comman/input";
import TextArea from "../../comman/textarea";
import { uploadFileToBlob } from "../../services/blobUploadService";
import { updateCandidateInvoicePayment, uploadCandidatePayDocument } from "../../app/store/candidate";

const schema = {
  paidAmount: Joi.number().required().label("Amount to Pay ($)"),
  invoiceAmount: Joi.number().required().label("Invoice Amount"),
};

function CandidatePay(props) {
  const {
    selectedObj,
    invType,
    timeLogInvoices,
    candidateObj,
    getInvoiceAmount,
    entType,
    payShowHide,
    handlePayShowHide,
    entityType
  } = props;

  console.log("CandidatePay props", props);
  const [data, setData] = useState({});
  const [errors, setErrors] = useState({});
  const [documents, setDocuments] = useState([]);
  const [isProcessing, setIsProcessing] = useState(false);
  const dispatch = useDispatch();

  const validate = (currentData = data) => {
    const options = { abortEarly: false, allowUnknown: true };
    const result = Joi.validate(currentData, schema, options);
    if (!result.error) return null;
    const nextErrors = {};
    for (const item of result.error.details) {
      if (item.type === "any.required") nextErrors[item.path[0]] = item.message;
    }
    return Object.keys(nextErrors).length > 0 ? nextErrors : null;
  };

  const validateProperty = ({ name, value }) => {
    const obj = { [name]: value };
    if (schema[name] === undefined) return null;
    const fieldSchema = { [name]: schema[name] };
    const { error } = Joi.validate(obj, fieldSchema);
    return error ? error.details[0].message : null;
  };

  const handleChange = ({ currentTarget: input }) => {
    const nextErrors = { ...errors };
    const errorMessage = validateProperty(input);
    if (errorMessage) nextErrors[input.name] = errorMessage;
    else delete nextErrors[input.name];

    const nextData = { ...data, [input.name]: input.value };

    if (input.name === "paidAmount") {
      const invoiceAmount = parseFloat(nextData.invoiceAmount) || 0;
      const enteredAmount = parseFloat(input.value) || 0;

      if (enteredAmount > invoiceAmount) {
        nextErrors[input.name] =
          "Amount to Pay cannot be greater than Invoice Amount!";
      } else if (enteredAmount === 0) {
        nextErrors[input.name] = "Amount to Pay must be a number";
      } else {
        delete nextErrors[input.name];
      }
    }

    setData(nextData);
    setErrors(nextErrors);
  };

  const doSubmit = async () => {

    if (Object.keys(errors).length > 0) {
      getAlert("Please fill Appropriate data before Submission.", "", "error");
      return;
    }

    if (data.paidAmount === "") {
      getAlert("Please fill Appropriate data before Submission.", "", "error");
      return;
    }

    const resultAlert = await getConfirmAlert(
      "Are you sure?",
      "You want to Add payment",
      "warning"
    );


    if (resultAlert.isConfirmed) {
      const user = auth.getCurrentUser();
      const { wfTask: workflowTask, handlePayShowHide } = props;
      const payload = { ...data };
      let docId = 0;
      console.log("documents", documents);
      if (documents.length > 0 && workflowTask) {
        const frmData = new FormData();
        frmData.append("message", payload.payNotes);
        frmData.append("workflowTask", JSON.stringify(workflowTask));
        frmData.append("userId", user.id);
        frmData.append(
          "files",
          JSON.stringify(
            documents.map((file) => ({
              name: file.name,
              type: file.type,
              size: file.size,
            }))
          )
        );
        const result = await dispatch(uploadCandidatePayDocument(frmData));
        docId = result?.uploadId;
        if (docId > 0) {
          payload.payDocId = docId;
          await dispatch(updateCandidateInvoicePayment(payload));
          await Promise.all(
            documents.map((file, key) => {
              if (!file.file) return Promise.resolve();
              return uploadFileToBlob(
                file.file,
                result.sasUrls[key].uploadUrl,
                (progress) => {
                  console.log(`Upload progress for ${file.name}: ${progress}%`);
                }
              );
            })
          );
          handlePayShowHide("save");
          getAlert("Sent Successfully", "", "success");
        }
        return;
      }
      payload.payDocId = docId;
      await dispatch(updateCandidateInvoicePayment(payload));
      handlePayShowHide("save");
      getAlert("Sent Successfully", "", "success");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isProcessing) return;
    const formErrors = validate();
    setErrors(formErrors || {});
    if (formErrors) return;
    setIsProcessing(true);
    try {
      await doSubmit();
    } finally {
      setIsProcessing(false);
    }
  };

  const onFileChange = async (event) => {
    const docs = [...documents];
    for (const file of event.target.files) {
      docs.push({
        name: file.name,
        type: file.type,
        file,
        size: file.size,
      });
    }
    setDocuments(docs);
  };

  const handleFileRemove = (item) => {
    const index = documents.indexOf(item);
    if (index !== -1) {
      const nextDocuments = [...documents];
      nextDocuments.splice(index, 1);
      setDocuments(nextDocuments);
    }
  };

  const getPerdeimAmount = () => {
    const { getTotalDays, selectedObj, getFieldData, candidateObj } = props;
    if (!getTotalDays) return 0;
    const perfData = candidateObj.performerData;
    return (
      getTotalDays(selectedObj) *
      getFieldData(perfData, "candidateonboardingform", "Per_Diem_Rate")
    );
  };

  useEffect(() => {
    if (selectedObj !== undefined && selectedObj !== "") {
      const obj = selectedObj;
      const nextData = {};
      let invoType = invType;
      if (invType === "subcontractor") {
        if (!(entType === "C2C Basis" && candidateObj?.rates?.subcontractorRate)) {
          invoType = "candidate";
        }
      }

      // Always use the parent's month/year-aware rate calculation (matches
      // the rate that was effective for the specific invoice period) instead
      // of the candidate's current flat rate, which would be wrong for any
      // past month after a rate change.
      let fAmt = parseFloat(getInvoiceAmount(obj) || 0);
      const invItems = timeLogInvoices.filter((x) => x.timeLogId === obj.id);

      if (invItems.length > 0) {
        const selectedInvoice = invItems[0];
        if (selectedInvoice?.adjustmentMinues > 0) {
          fAmt -= selectedInvoice.adjustmentMinues;
        }
        if (selectedInvoice?.adjustmentPlus > 0) {
          fAmt += selectedInvoice.adjustmentPlus;
        }
        if (selectedInvoice?.adpDeduction > 0) {
          fAmt -= selectedInvoice.adpDeduction;
        }

        nextData.paymentMode = selectedInvoice.paymentMode;
        nextData.payNotes = selectedInvoice.payNotes;
        nextData.paidAmount = selectedInvoice.paidAmount;
        nextData.paymentDate = selectedInvoice.paymentDate?.split("T")[0];
      }

      nextData.id = obj.id;
      nextData.invoiceAmount = parseFloat(fAmt).toFixed(2);
      nextData.InvoiceType = invoType;
      nextData.paidAmount = parseFloat(fAmt).toFixed(2);

      setDocuments([]);
      setData(nextData);
      setErrors({});
    } else {
      setDocuments([]);
      setData({});
      setErrors({});
    }
  }, [
    selectedObj,
    invType,
    timeLogInvoices,
    candidateObj,
    getInvoiceAmount,
    entType,
  ]);

  const dueAmount = useMemo(() => {
    if (
      data.paidAmount !== undefined &&
      data.paidAmount !== "" &&
      data.paidAmount !== null
    ) {
      return parseFloat(
        parseFloat(data.invoiceAmount || 0) - parseFloat(data.paidAmount || 0)
      ).toFixed(2);
    }
    return parseFloat(data.invoiceAmount || 0).toFixed(2);
  }, [data.invoiceAmount, data.paidAmount]);

  const perDiem = useMemo(() => {
    if (props.selectedObj !== "") return getPerdeimAmount();
    return undefined;
  }, [props.selectedObj, props.getTotalDays, props.candidateObj]);

  const isAlreadyPaid = useMemo(() => {
    if (!selectedObj || !timeLogInvoices) return false;
    const invItems = timeLogInvoices.filter((x) => x.timeLogId === selectedObj.id);
    if (invItems.length > 0) {
      const selectedInvoice = invItems[0];
      return !!(
        selectedInvoice?.paymentMode ||
        selectedInvoice?.paymentDate ||
        selectedInvoice?.payDocId > 0
      );
    }
    return false;
  }, [selectedObj, timeLogInvoices]);

  const renderInput = (name, label, type = "text", forcedValue) => (
    <Input
      type={type}
      name={name}
      value={forcedValue ?? data[name] ?? ""}
      label={label}
      onChange={handleChange}
      error={errors[name]}
      req={schema[name]}
      disabled={isAlreadyPaid}
    />
  );

  const renderTextArea = (name, label) => (
    <TextArea
      name={name}
      value={data[name] || ""}
      label={label}
      onChange={handleChange}
      error={errors[name]}
      req={schema[name]}
      disabled={isAlreadyPaid}
    />
  );


  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: `
        /* Ensure the modal and backdrop are on top of other elements */
        .modal-backdrop {
          z-index: 1080 !important;
        }
        .modal {
          z-index: 1090 !important;
          overflow-y: hidden !important;
        }

        /* Glassmorphic backdrop filter and blur */
        .modal-backdrop.show {
          backdrop-filter: blur(8px) !important;
          -webkit-backdrop-filter: blur(8px) !important;
          background-color: rgba(15, 23, 42, 0.45) !important;
          opacity: 1 !important;
        }

        /* Spring-like transition for scale-in animation */
        .modal.fade .wf-pay-modal.modal-dialog {
          transform: scale(0.96) !important;
          transition: transform 0.25s cubic-bezier(0.34, 1.56, 0.64, 1) !important;
        }
        .modal.show .wf-pay-modal.modal-dialog {
          transform: scale(1) !important;
        }

        .wf-pay-modal {
          max-width: 720px !important;
          width: 100% !important;
          font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
        }

        .wf-pay-modal .modal-content {
          border-radius: 0 !important;
          border: 1px solid #cbd5e1 !important;
          box-shadow: 0 25px 50px -12px rgba(15, 23, 42, 0.25) !important;
          overflow: hidden !important;
          background: #ffffff !important;
        }

        .wf-pay-modal .modal-header {
          position: relative !important;
          display: block !important;
          padding: 14px 24px !important;
          background: #ffffff !important;
          border-bottom: 1px solid #edf2f7 !important;
          overflow: hidden !important;
        }

        .wf-pay-modal .modal-header::before {
          display: none !important;
        }

        .wf-pay-modal .rt-header-shell {
          display: flex !important;
          flex-direction: column !important;
          gap: 0 !important;
          width: 100% !important;
        }

        .wf-pay-modal .rt-header-top {
          display: flex !important;
          justify-content: space-between !important;
          align-items: center !important;
          gap: 16px !important;
          width: 100% !important;
        }

        .wf-pay-modal .rt-header-main {
          display: flex !important;
          align-items: center !important;
          gap: 14px !important;
          min-width: 0 !important;
          flex: 1 1 auto !important;
        }

        .wf-pay-modal .rt-header-copy {
          display: flex !important;
          flex-direction: column !important;
          gap: 2px !important;
          min-width: 0 !important;
        }

        .wf-pay-modal .rt-modal-title {
          display: inline-flex !important;
          align-items: center !important;
          margin: 0 !important;
          color: #0f172a !important;
          font-size: 17px !important;
          font-weight: 600 !important;
          line-height: 1.25 !important;
        }

        .wf-pay-modal .rt-header-icon {
          width: 38px !important;
          height: 38px !important;
          min-height: 38px !important;
          border-radius: 0 !important;
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          color: #171717 !important;
          background: #f5f5f5 !important;
          border: 1px solid #d4d4d4 !important;
          box-shadow: 0 2px 5px rgba(15,23,42,0.06) !important;
          font-size: 16px !important;
          flex-shrink: 0 !important;
        }

        .wf-pay-modal .rt-modal-title-text {
          display: inline-flex !important;
          align-items: center !important;
          gap: 8px !important;
          flex-wrap: wrap !important;
        }

        .wf-pay-modal .rt-modal-title-badge {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          padding: 3px 8px !important;
          border-radius: 0 !important;
          font-size: 10px !important;
          font-weight: 700 !important;
          text-transform: uppercase !important;
          letter-spacing: 0.04em !important;
          background: #171717 !important;
          color: #ffffff !important;
          border: 1px solid #171717 !important;
        }

        .wf-pay-modal .rt-modal-desc {
          display: inline-flex !important;
          align-items: center !important;
          gap: 6px !important;
          color: #64748b !important;
          font-weight: 500 !important;
          line-height: 1.4 !important;
          font-size: 12px !important;
        }
        .wf-pay-modal .rt-modal-desc i {
          color: #64748b !important;
        }

        .wf-pay-modal .rt-action-btn {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          width: 32px !important;
          height: 32px !important;
          padding: 0 !important;
          font-size: 14px !important;
          color: #64748b !important;
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          border-radius: 0 !important;
          cursor: pointer !important;
          transition: all 0.2s ease !important;
          box-shadow: 0 2px 5px rgba(15, 23, 42, 0.06) !important;
          outline: none !important;
        }
        .wf-pay-modal .rt-action-btn:hover {
          color: #ef4444 !important;
          border-color: #fca5a5 !important;
          background: #fef2f2 !important;
          transform: translateY(-1px) !important;
        }

        .wf-pay-modal .modal-body {
          padding: 24px !important;
          background: #ffffff !important;
          max-height: calc(90vh - 140px) !important;
          overflow-y: auto !important;
        }

        .wf-pay-modal .form-group {
          margin-bottom: 16px !important;
        }

        .wf-pay-modal label.form-control-label {
          display: block !important;
          font-size: 12px !important;
          font-weight: 600 !important;
          color: #334155 !important;
          margin-bottom: 6px !important;
          letter-spacing: 0.01em !important;
        }

        .wf-pay-modal .form-control {
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          border-radius: 0 !important;
          padding: 8px 12px !important;
          font-size: 13.5px !important;
          font-weight: 500 !important;
          color: #0f172a !important;
          transition: all 0.2s ease !important;
          box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04) !important;
          outline: none !important;
        }

        .wf-pay-modal .form-control:focus {
          border-color: #2563eb !important;
          box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.12) !important;
        }
        
        .wf-pay-modal .form-control::placeholder {
          color: #94a3b8 !important;
          font-weight: 400 !important;
        }

        .wf-pay-modal textarea.form-control {
          min-height: 72px !important;
          resize: vertical !important;
        }

        /* Due Amount Highlight Card */
        .wf-pay-modal .wf-due-amount-value-card {
          height: 38px !important;
          display: flex !important;
          align-items: center !important;
          justify-content: flex-start !important;
          padding: 8px 12px !important;
          font-size: 13.5px !important;
          font-weight: 700 !important;
          border-radius: 0 !important;
          outline: none !important;
          background-color: #f8fafc !important;
          border: 1px solid #cbd5e1 !important;
          color: #1e293b !important;
          box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04) !important;
        }
        
        .wf-pay-modal .wf-due-amount-value-card.is-zero {
          background-color: #f0fdf4 !important;
          border-color: #bbf7d0 !important;
          color: #15803d !important;
        }

        /* Per Diem Highlight Card */
        .wf-pay-modal .wf-perdiem-amount-value-card {
          height: 38px !important;
          display: flex !important;
          align-items: center !important;
          padding: 8px 12px !important;
          font-size: 13.5px !important;
          font-weight: 700 !important;
          border-radius: 0 !important;
          outline: none !important;
          background-color: #f5f3ff !important;
          border: 1px solid #ddd6fe !important;
          color: #7c3aed !important;
          box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04) !important;
        }

        /* Payment Mode Selector Cards */
        .wf-pay-modal .wf-pay-section-label {
          font-size: 12px !important;
          font-weight: 700 !important;
          color: #1e293b !important;
          letter-spacing: 0.03em !important;
          text-transform: uppercase !important;
          margin-bottom: 10px !important;
          display: block !important;
        }

        .wf-pay-modal .wf-pay-mode-cards-group {
          display: grid !important;
          grid-template-columns: 1fr 1fr !important;
          gap: 12px !important;
          width: 100% !important;
          margin-bottom: 16px !important;
        }

        .wf-pay-modal .wf-pay-mode-card-wrap {
          width: 100% !important;
        }

        .wf-pay-modal .wf-pay-mode-radio-input {
          display: none !important;
        }

        .wf-pay-modal .wf-pay-mode-card {
          display: flex !important;
          align-items: center !important;
          gap: 12px !important;
          padding: 12px 16px !important;
          border-radius: 0 !important;
          border: 1px solid #cbd5e1 !important;
          background: #ffffff !important;
          cursor: pointer !important;
          transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
          margin-bottom: 0 !important;
          user-select: none !important;
          width: 100% !important;
          position: relative !important;
          box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04) !important;
        }

        .wf-pay-modal .wf-pay-mode-card:hover {
          border-color: #94a3b8 !important;
          background: #f8fafc !important;
          transform: translateY(-1px) !important;
          box-shadow: 0 4px 8px rgba(15, 23, 42, 0.06) !important;
        }

        .wf-pay-modal .wf-pay-mode-card-icon {
          width: 32px !important;
          height: 32px !important;
          border-radius: 0 !important;
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          font-size: 15px !important;
          flex-shrink: 0 !important;
        }

        .wf-pay-modal .wf-pay-mode-card-text {
          display: flex !important;
          flex-direction: column !important;
          gap: 1px !important;
          min-width: 0 !important;
        }

        .wf-pay-modal .wf-pay-mode-card-title {
          font-size: 14px !important;
          font-weight: 700 !important;
          color: #0f172a !important;
          letter-spacing: 0.01em !important;
        }

        .wf-pay-modal .wf-pay-mode-card-desc {
          font-size: 11.5px !important;
          color: #64748b !important;
          font-weight: 400 !important;
          line-height: 1.3 !important;
        }

        /* Active Radio Card Styles */
        .wf-pay-modal .cheque-card .wf-pay-mode-card-icon {
          color: #2563eb !important;
          background: #eff6ff !important;
          border: 1px solid #bfdbfe !important;
        }

        .wf-pay-modal .ach-card .wf-pay-mode-card-icon {
          color: #7c3aed !important;
          background: #faf5ff !important;
          border: 1px solid #ddd6fe !important;
        }

        .wf-pay-modal .wf-pay-mode-radio-input:checked + .cheque-card {
          border-color: #2563eb !important;
          background: #eff6ff !important;
          box-shadow: 0 0 0 1px #2563eb, 0 4px 10px rgba(37, 99, 235, 0.08) !important;
        }
        .wf-pay-modal .wf-pay-mode-radio-input:checked + .cheque-card .wf-pay-mode-card-title {
          color: #1d4ed8 !important;
        }

        .wf-pay-modal .wf-pay-mode-radio-input:checked + .ach-card {
          border-color: #7c3aed !important;
          background: #faf5ff !important;
          box-shadow: 0 0 0 1px #7c3aed, 0 4px 10px rgba(124, 58, 237, 0.08) !important;
        }
        .wf-pay-modal .wf-pay-mode-radio-input:checked + .ach-card .wf-pay-mode-card-title {
          color: #6d28d9 !important;
        }

        /* Helper alerts */
        .wf-pay-modal .wf-pay-helper-alert {
          padding: 10px 14px !important;
          border-radius: 0 !important;
          font-size: 12.5px !important;
          font-weight: 500 !important;
          display: flex !important;
          align-items: center !important;
          gap: 8px !important;
          margin-bottom: 16px !important;
          border: 1px solid transparent !important;
        }

        .wf-pay-modal .ach-alert {
          background: #faf5ff !important;
          border-color: #ddd6fe !important;
          color: #6d28d9 !important;
        }

        .wf-pay-modal .cheque-alert {
          background: #eff6ff !important;
          border-color: #bfdbfe !important;
          color: #1d4ed8 !important;
        }

        .wf-pay-modal .modal-footer {
          background: #f8fafc !important;
          border-top: 1px solid #edf2f7 !important;
          padding: 14px 24px !important;
          display: flex !important;
          justify-content: flex-end !important;
          gap: 10px !important;
        }

        .wf-pay-modal .wf-modal-footer-close-btn {
          display: inline-flex !important;
          align-items: center !important;
          gap: 6px !important;
          padding: 7px 14px !important;
          font-size: 13.5px !important;
          font-weight: 500 !important;
          color: #1e293b !important;
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          border-radius: 0 !important;
          box-shadow: 0 2px 5px rgba(15, 23, 42, 0.06) !important;
          cursor: pointer !important;
          transition: all 0.2s ease !important;
          outline: none !important;
        }
        .wf-pay-modal .wf-modal-footer-close-btn:hover {
          background: #f8fafc !important;
          color: #0f172a !important;
          border-color: #94a3b8 !important;
          box-shadow: 0 3px 8px rgba(15, 23, 42, 0.1) !important;
        }

        .wf-pay-modal .wf-btn-save {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          gap: 7px !important;
          padding: 7px 16px !important;
          border-radius: 0 !important;
          border: 1px solid #2563eb !important;
          background: #2563eb !important;
          color: #ffffff !important;
          font-size: 13.5px !important;
          font-weight: 500 !important;
          cursor: pointer !important;
          transition: all 0.2s ease !important;
          outline: none !important;
          box-shadow: 0 2px 5px rgba(37, 99, 235, 0.2) !important;
        }
        .wf-pay-modal .wf-btn-save:hover {
          background: #1d4ed8 !important;
          border-color: #1d4ed8 !important;
          transform: translateY(-1px) !important;
          box-shadow: 0 3px 8px rgba(37, 99, 235, 0.28) !important;
        }
        .wf-pay-modal .wf-btn-save:active {
          transform: scale(0.97) !important;
        }
        .wf-pay-modal .wf-btn-save:disabled {
          background: #cbd5e1 !important;
          border-color: #cbd5e1 !important;
          color: #94a3b8 !important;
          cursor: not-allowed !important;
          box-shadow: none !important;
          transform: none !important;
        }
` }} />
      <Modal show={payShowHide} size="lg" dialogClassName="wf-pay-modal" centered>
        <Modal.Header>
          <div className="rt-header-shell">
            <div className="rt-header-top">
              <div className="rt-header-main">
                <i className="rt-header-icon fa fa-credit-card" aria-hidden="true" />
                <div className="rt-header-copy">
                  <h2 className="rt-modal-title">
                    <span className="rt-modal-title-text">
                      <span>
                        {invType === "subcontractor" && "Payment"}
                        {invType === "recruiter" && "Payment to Recruiter"}
                        {invType === "agency" && "Payment Received Status"}
                      </span>
                      <span className="rt-modal-title-badge">Transaction</span>
                    </span>
                  </h2>
                  <span className="rt-modal-desc">
                    <i className="fa fa-info-circle" aria-hidden="true" /> Record payments, set dates, specify payment modes, and add notes.
                  </span>
                </div>
              </div>
              <button
                type="button"
                className="rt-action-btn"
                onClick={() => handlePayShowHide("close", "")}
                title="Close"
              >
                <i className="fa fa-times" aria-hidden="true" />
              </button>
            </div>
          </div>
        </Modal.Header>
        <Modal.Body className="border-0">
          <div className="row">
            {entityType === "W2 Basis" && invType === "subcontractor" ? (
              <div className="col-md-6">{renderInput("invoiceAmount", "Net Pay ($)", "number")}</div>
            ) : (
              <div className="col-md-4">{renderInput("invoiceAmount", "Invoice Amount ($)", "number")}</div>
            )}

            {!(entityType === "W2 Basis" && invType === "subcontractor") && (
              <div className="col-md-4">
                {renderInput(
                  "paidAmount",
                  `${invType === "agency"
                    ? "Payment Amount Received"
                    : "Amount to Pay ($)"
                  }`,
                  "number"
                )}
              </div>
            )}

            {entityType === "W2 Basis" && invType === "subcontractor" ? (
              <div className="col-md-6 form-group">
                <label className="form-control-label">Per Diem Amount ($)</label>
                <div className="wf-perdiem-amount-value-card">
                  {perDiem}
                </div>
              </div>
            ) : (
              <div className="col-md-4 form-group">
                <label className="form-control-label">Due Amount ($)</label>
                <div className={`wf-due-amount-value-card ${parseFloat(dueAmount || 0) <= 0 ? 'is-zero' : ''}`}>
                    ${parseFloat(dueAmount || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  </div>
              </div>
            )}

            <div className="col-md-12">{renderInput("paymentDate", "Payment Date", "date")}</div>

            <div className="col-md-12">
              <span className="wf-pay-section-label">Payment Mode</span>
              <div className="wf-pay-mode-cards-group">
                 <div className="wf-pay-mode-card-wrap">
                  <input
                    name="paymentMode"
                    type="radio"
                    id="byCheck"
                    className="wf-pay-mode-radio-input"
                    onChange={handleChange}
                    value="Cheque"
                    checked={data.paymentMode === "Cheque"}
                    disabled={isAlreadyPaid}
                  />
                  <label className="wf-pay-mode-card cheque-card" htmlFor="byCheck">
                    <div className="wf-pay-mode-card-icon">
                      <i className="fa fa-money" aria-hidden="true" />
                    </div>
                    <div className="wf-pay-mode-card-text">
                      <span className="wf-pay-mode-card-title">By Cheque</span>
                      <span className="wf-pay-mode-card-desc">Pay using physical printed cheque</span>
                    </div>
                  </label>
                </div>

                <div className="wf-pay-mode-card-wrap">
                  <input
                    name="paymentMode"
                    type="radio"
                    id="byAch"
                    className="wf-pay-mode-radio-input"
                    onChange={handleChange}
                    value="ACH"
                    checked={data.paymentMode === "ACH"}
                    disabled={isAlreadyPaid}
                  />
                  <label className="wf-pay-mode-card ach-card" htmlFor="byAch">
                    <div className="wf-pay-mode-card-icon">
                      <i className="fa fa-university" aria-hidden="true" />
                    </div>
                    <div className="wf-pay-mode-card-text">
                      <span className="wf-pay-mode-card-title">By ACH</span>
                      <span className="wf-pay-mode-card-desc">Direct electronic bank transfer</span>
                    </div>
                  </label>
                </div>
              </div>
            </div>

            {data.paymentMode && (
              <div className="col-md-12">
                {data.paymentMode === "ACH" && (
                  <div className="wf-pay-helper-alert ach-alert">
                    <i className="fa fa-info-circle" /> Payment will be processed via ACH Electronic Bank Transfer.
                  </div>
                )}
                {data.paymentMode === "Cheque" && (
                  <div className="wf-pay-helper-alert cheque-alert">
                    <i className="fa fa-info-circle" /> Payment will be processed via Physical printed Check.
                  </div>
                )}
              </div>
            )}

            <div className="col-md-12">{renderTextArea("payNotes", "Notes")}</div>

            <div className="col-md-12">
              <UploadDocument
                documents={documents}
                onFileChange={onFileChange}
                handleFileRemove={handleFileRemove}
                btnLable={`${entityType === "W2 Basis" ? "Upload Pay Slip" : "Add"}`}
                disabled={isAlreadyPaid}
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="wf-modal-footer-close-btn"
            onClick={() => handlePayShowHide("close", "")}
          >
            <i className="fa fa-times" aria-hidden="true"></i> Close
          </button>
          <button
            className="wf-btn-save"
            onClick={handleSubmit}
            disabled={isProcessing || isAlreadyPaid || !!validate()}
          >
            <i
              className={`fa ${isProcessing ? "fa-spinner fa-spin" : "fa-paper-plane"}`}
              aria-hidden="true"
            ></i>{" "}
            Send
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default CandidatePay;
